import { Header, Modal } from '@leshen/ui' // Don't want the ModalWithState as we will create our own
import { MODAL } from '@leshen/ui/src/utils/dataTrackingValues'
import { Search } from 'emotion-icons/material'
import { graphql, useStaticQuery } from 'gatsby'
import React, { useState } from 'react'
import { useMapi } from '../context/MapiProvider'
import { useUser } from '../context/UserProvider'

import AvailabilityForm from './Form/Availability'
import Typography from './Typography'

// Gatsby integration of @leshen/ui/Link
import { usePhoneAvailability } from '../context/PhoneAvailabilityProvider'
import Link from './Link'

function LeshenHeader({ dark = false, spanish = false, ...props }) {
  const cobraData = useStaticQuery(graphql`
    query HeaderCobraQuery {
      site {
        siteMetadata {
          cobra {
            sitePath
            buttonLink
            buttonText
            buttonIcon
          }
        }
      }
    }
  `)

  const [showModal, setShowModal] = useState(false)
  const { rotatedNumber = '', requestId = '' } = useMapi() || {}
  const { userLocation } = useUser() || {}
  const phoneAvailability = usePhoneAvailability()

  const handleOpenModal = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  return (
    <Header
      userLocation={userLocation}
      dark={dark}
      phoneNumber={rotatedNumber}
      CustomLink={Link}
      spanish={spanish}
      requestId={requestId}
      cobraSettings={cobraData.site.siteMetadata.cobra || null}
      isPhoneAvailable={phoneAvailability}
      {...props}
    >
      <>
        {/* eslint-disable */}
        <span
          role="dialog"
          tabIndex="0"
          className="leshen-modal-trigger"
          data-tracking={MODAL.NAME}
          onClick={handleOpenModal}
          onKeyDown={(e) => {
            if (e.keyCode === 13 || e.keyCode === 32) {
              e.preventDefault()
              handleOpenModal()
            }
          }}
        >
          {spanish ? 'Cambio' : 'Change'}
        </span>
        <Modal
          isShowing={showModal}
          onClose={handleCloseModal}
          size="sm"
          closeTimeoutMS={0}
        >
          <h2>ZIP Code</h2>
          <Typography>
            Help us point you in the right direction.
            <br />
            Enter your ZIP code to get location specific support and offers.
          </Typography>
          <AvailabilityForm
            buttonText={<Search />}
            placeholderText="Zip Code"
            buttonColor="primary"
            label="ZIP Code*"
            setShowModal={setShowModal}
          />
          <Typography>
            Help me find my{' '}
            <Link
              target="_blank"
              to="https://tools.usps.com/go/ZipLookupAction!input.action"
            >
              ZIP code
            </Link>
          </Typography>
        </Modal>
      </>
    </Header>
  )
}
export default LeshenHeader
